// StripeContainer.js
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PropTypes from "prop-types";
import CheckoutForm from "./CheckoutForm";

const StripeContainer = ({ clientSecret }) => {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);

    const options = {
        clientSecret,
    };

    return (
        <Elements stripe={stripePromise} options={options}>
            <CheckoutForm clientSecret={clientSecret} />
        </Elements>
    );
};

StripeContainer.propTypes = {
    clientSecret: PropTypes.string.isRequired,
};

export default StripeContainer;
